import PropTypes from 'prop-types';

const allowedMessageMoods = [
  'error',
  'warning',
  'info',
  'success'
];

const allowedMessageProps = {
  id: PropTypes.string.isRequired,
  mood: PropTypes.oneOf(allowedMessageMoods).isRequired,
  message: PropTypes.string.isRequired
};

export {
  allowedMessageMoods,
  allowedMessageProps
};